// extracted by mini-css-extract-plugin
export default {"icon":"Assets_icon__LxmwG","name":"Assets_name__F58Ec"};